const queryToast = function () {

    return createToast();
};
const createToast = function () {

    const toast = document.createElement('div');
    toast.className = 'toast';

    const toastText = document.createElement('div');
    toastText.className = 'toast-text';

    toast.appendChild(toastText);
    document.body.appendChild(toast);

    setTimeout(function () {
        document.body.removeChild(toast);
    }, 1500)

    return toast;

};

export const ShowToast = function (text) {
    const toast = queryToast();
    toast.getElementsByClassName("toast-text")[0].innerHTML = text;
    toast.style.display = "block";
};